<template>
  <div class="programlist">
    <section id="programme-episode" class="section-group">
      <h2 class="side-title">
       {{ $t('Video.programlist.episodes') }}
        <span class="now-playing" >{{ getno }}/{{ gettotal }}</span>
      </h2>
      <div class="scroll-menu">
        <div
          class="video-card card mb-1"
          :class="{ playing: id == item.id }"
          v-for="item in datalist"
          v-bind:key="item.id"
        >
          <!-- <a href="#" @click="changemovie(item.id)"> -->
          <router-link
            @click.native="changemovie(item.id)"
            :to="{
              name: 'WatchVideo',
              params: { id: item.id, itemtype: 'programselect' },
            }"
          >
            <div class="video-block">
              <div class="video-thumbnail">
                <div class="video-responsive">
                  <div class="video-sizer">
                    <div
                      class="video-image"
                      :style="{
                        backgroundImage: 'url(' + `${item.imageFile}` + '),url(' + `${require('../../assets/images/404.png')}` + ')',
                      }"
                    ></div>
                  </div>
                </div>
                <div class="video-duration">
                  <span>{{ item.mov_VSourceTimeFormat }}</span>
                </div>
              </div>
            </div>
            <div class="video-info p-2">
              <div class="video-episode" v-if="item.sgL_NumberNo>0">Ep.{{ item.sgL_NumberNo }}</div>
              <div class="video-title" :title="item.sgL_Mov_VSubject">
                {{ item.sgL_Mov_VSubject }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      programdata: null,
      routerAlive: true,
      no: 0,
      id: 0,
      total: 0,
    };
  },
  //["aboutprogramList"],
  props: ["aboutprogramList", "currentNo","currentId"],

  created() {
    this.$store.dispatch("updateCurrentIndex", 1);
  },
  methods: {
    changemovie(id) {
      this.$emit("changemovie", id);
    },
  },
  watch: {
    aboutprogramList: {
      handler(newValue, oldValue) {
        this.programdata = newValue.items;
        if (this.programdata != null) {
          this.total = this.programdata.length;
        }
      },
      deep: true,
    },
    currentNo(newvalue, oldvalue) {
      this.no = newvalue;
    },
    currentId(newvalue, oldvalue) {
      this.id = newvalue;
    },
    // //监听aboutdata数据变化
    // aboutprogramList(newdata, olddata) {
    //   this.programdata = newdata;
    // }
  },
  computed: {
    datalist() {
      return this.programdata;
    },
    getno() {
      return this.no;
    },
    getid(){
      return this.id
    },
    gettotal() {
      return this.total;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Video/programlist.vue